import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
    >
      {children}
    </Tag>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className={`block ${innerClassName}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ kicker, title, description, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {kicker && (
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold" data-testid="section-kicker">
          {kicker}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="mt-5 font-serif text-3xl font-medium leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base leading-relaxed text-zinc-400 md:text-lg">{description}</p>
      </Reveal>
    )}
  </div>
);

export const GoldButton = ({ href, children, testId, external = false, className = "" }) => (
  <a
    href={href}
    data-testid={testId}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className={`group inline-flex items-center justify-center gap-3 rounded-full bg-gold px-8 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-obsidian transition-[background-color,transform] duration-300 hover:bg-gold-hover hover:-translate-y-0.5 ${className}`}
  >
    {children}
  </a>
);

export const GhostButton = ({ href, children, testId, className = "" }) => (
  <a
    href={href}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-3 rounded-full border border-white/20 px-8 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-white transition-[border-color,background-color,transform] duration-300 hover:border-gold hover:text-gold hover:-translate-y-0.5 ${className}`}
  >
    {children}
  </a>
);
